import { render, staticRenderFns } from "./ModalImportCnisForm.vue?vue&type=template&id=17053107"
import script from "./ModalImportCnisForm.vue?vue&type=script&lang=js"
export * from "./ModalImportCnisForm.vue?vue&type=script&lang=js"
import style0 from "./ModalImportCnisForm.vue?vue&type=style&index=0&id=17053107&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../ChatGenial-hom-sync/client/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports